import React from "react";
import {
  getDataFromConfig,
  getSummaryCardDummyDatabyCardID,
} from "../../../../../../../../../features/salescodeStudio/mandatoryConfigs/manageKPIReview/manageKpiReviewServices";
import "./summaryCards.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";

interface SummaryCardsProps {
  kpi: any;
  defaultConfigGlobal : Record<string,any>;
}
const SummaryCards: React.FC<SummaryCardsProps> = ({ kpi ,defaultConfigGlobal }) => {
  const date = new Date().toLocaleDateString();

  const summaryCardsData: Record<string, any>[] = getDataFromConfig(
    "KPI_summary_card_data",
    kpi.id,defaultConfigGlobal 
  );

  return (
    <div className="summary-cards-container">
      {summaryCardsData.map(
        (summaryCardData: Record<string, any>, index: number) => {
          const usefulDataPoints = summaryCardData.data_points.filter(
            (data: Record<string, any>) =>
              !Object.keys(data).includes("validation")
          );

          const title = summaryCardData.title;
          const dummydata = getSummaryCardDummyDatabyCardID(summaryCardData.id);
          const allDataValues = summaryCardData.data_points;
          const dataValueForHeader = allDataValues[0];
          const dataValuesForBody = allDataValues.splice(
            1,
            allDataValues.length
          );
          return (
            <div key={index} className="summary-card-container">
              <div className="summary-card-header">
                <div className="summary-card-header-left">
                  <span className="summary-card-title">{title}</span>
                  <div className="summary-card-date-container">
                    <FontAwesomeIcon
                      icon={faCalendarDays}
                      className="summary-card-calendar-icon"
                    />{" "}
                    <span className="summary-card-date">{date}</span>
                  </div>
                </div>
                <div className="summary-card-header-right">
                  <div className="summary-card-header-data-container">
                    <div className="summary-card-header-value">
                      {" "}
                      {dummydata[dataValueForHeader.id]}
                    </div>
                    <div className="summary-card-header-percent">%</div>
                  </div>
                  <div className="summary-card-header-data-label">
                    {dataValueForHeader.label}
                  </div>
                </div>
              </div>
              <div className="summary-card-body">
                {dataValuesForBody.map(
                  (data: Record<string, any>, dpIndex: number) => (
                    <div key={dpIndex} className="summary-card-data-point">
                      <div className="summary-card-data-point-value">
                        {" "}
                        {dummydata[data.id]}
                      </div>
                      <div className="summary-card-data-point-label">
                        {data.label}
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
          );
        }
      )}
    </div>
  );
};

export default SummaryCards;
